export default {
  data() {
    return {
      assign: {
        module: {
          id: null,
          dialog: false,
        },
        unit: {
          id: null,
          dialog: false,
        },
        playlist: {
          id: null,
          dialog: false,
        },
      },
      share: {
        module: {
          id: null,
          dialog: false,
        },
        unit: {
          id: null,
          dialog: false,
        },
        playlist: {
          id: null,
          dialog: false,
          playlist: [],
        },
      },
    };
  },
  methods: {
    shareContent(item) {
      const { content_type } = item;
      if (content_type === 'Playlist') {
        this.share.playlist.id = this.determineId(item);
        this.share.playlist.playlist = [
          {
            id: this.determineId(item),
            name: item.name,
          },
        ];

        this.share.playlist.dialog = true;
        return;
      }

      if (content_type === 'Module') {
        this.share.module.dialog = true;
        this.share.module.id = this.determineId(item);
        return;
      }

      this.share.unit.dialog = true;
      this.share.unit.id = this.determineId(item);
    },
    assignContent(item) {
      const { content_type } = item;
      if (content_type === 'Playlist') {
        this.assign.playlist.dialog = true;
        this.assign.playlist.id = this.determineId(item);
      }

      if (content_type === 'Module') {
        this.assign.module.dialog = true;
        this.assign.module.id = this.determineId(item);
      }

      if (content_type === 'Unit') {
        this.assign.unit.dialog = true;
        this.assign.unit.id = this.determineId(item);
      }
    },
    determineContentType(type) {
      if (type === 'Playlist') {
        return 'Playlist';
      }
      if (type === 'Module') {
        return 'CertificationModulePage';
      }
      return 'UnitPage';
    },
    determineId(item) {
      if (item.content_type === 'Playlist') {
        return item.playlist_id;
      }

      if (item.content_type === 'Module') {
        return item.module_id;
      }

      return item.unit_id;
    },
    goToContent(item) {
      const id = this.determineId(item);

      this.openLink(item.content_type, id);
    },
    openLink(type, id) {
      const pageName = this.determineContentType(type);

      const route = this.$router.resolve({ name: pageName, params: { id } });

      window.open(route.href, '_blank');
    },
    unfinishedContents(item) {
      const contentType = item.content_type.toLowerCase();
      const contentId = this.determineId(item);

      if (contentType === 'unit') {
        return;
      }

      this.loading.unfinishedContents = true;

      this.$http
        .get('client/lms/assigned-and-shared-contents/unfinished-contents', {
          params: {
            content_type: contentType,
            content_id: contentId,
            is_assigned: true,
          },
        })
        .then(({ data }) => {
          this.$store.dispatch(
            'assignedAndSharedContents/setShowDialogState',
            true
          );
          this.$store.dispatch('assignedAndSharedContents/setUnitsState', data);

          this.$nextTick(() => {
            this.loading.unfinishedContents = false;
          });
        });
    },
  },
};
